import axios from "axios";
import {Navigate } from "react-router-dom";
import React from "react";


const AuthService = {
    login: async (userData) => {
        userData.data.expires_in_date = Date.now() + ((userData.data.expires_in - 10) * 1000);

        if (!userData.data.user.profile_image) {
            userData.data.user.profile_image = process.env.REACT_APP_URL_STORAGE + 'src/perfil_icone.png';
        }

        localStorage.setItem('users', JSON.stringify(userData));
    },
    logout: () => {
        localStorage.clear();
    },
    isAuthenticated: () => {
        const user = localStorage.getItem('users');
        if (!user) {
            return false;
        }
        try {
            const userData = JSON.parse(user);

            const expirationDate = new Date(userData.data.expires_in_date);
            const currentDate = new Date();

            if (expirationDate < currentDate) {
                localStorage.removeItem('users');
                return false;
            }
            return true;
        } catch (e) {
            return false;
        }
    },
    getUserData:  () => {
        try {
            const userData = localStorage.getItem("users");
            if (!userData) return null;

            const parsedData = JSON.parse(userData);

            // Validar expiração do token (se não tem expires_in_date, aceita o token)
            if (parsedData?.expires_in_date && parsedData.expires_in_date < Date.now()) {
                localStorage.removeItem("users");
                localStorage.removeItem("owner");
                return null;
            }

            // Token precisa existir
            if (!parsedData?.token) {
                localStorage.removeItem("users");
                return null;
            }

            return parsedData?.user || null;
        } catch (error) {
            localStorage.removeItem("users");
            localStorage.removeItem("owner");
            return null;
        }
    },

    setPlan: (planId) => {

        const userData = localStorage.getItem('users');
        if (!userData) {
            return null;
        }

        // Acessa diretamente o objeto `data.user`
        const parsedData = JSON.parse(userData);
        parsedData.user.payment_plans_id = planId;
        localStorage.setItem('users', JSON.stringify(parsedData));
    },
    setUserValue: (subKey, value) => {
        const storedData = localStorage.getItem("users");
        if (!storedData) {
            return false;
        }

        // Converte para objeto
        const parsedData = JSON.parse(storedData);

        // Divide a chave e percorre os níveis do objeto
        let keys = subKey.split(".");
        let obj = parsedData.data.user; // Sempre modifica dentro de `data.user`

        for (let i = 0; i < keys.length - 1; i++) {
            if (!obj[keys[i]]) {
                obj[keys[i]] = {}; // Cria um objeto vazio se o caminho não existir
            }
            obj = obj[keys[i]];
        }

        obj[keys[keys.length - 1]] = value;

        // Salva de volta no localStorage
        parsedData.data.user = obj;
        localStorage.setItem("users", JSON.stringify(parsedData));

        return true; // Indica sucesso na atualização
    },
    getToken: () => {
        const userData = localStorage.getItem('users');
        if (!userData) return null;

        try {
            const parsedData = JSON.parse(userData);
            // Validar expiração
            if (parsedData?.expires_in_date && parsedData.expires_in_date < Date.now()) {
                localStorage.removeItem("users");
                localStorage.removeItem("owner");
                return null;
            }
            return parsedData.token || null;
        } catch {
            localStorage.removeItem("users");
            return null;
        }
    },
    getCompanyId: () => {
        const userData = localStorage.getItem("users");
        if (!userData) return null;

        const parsedData = JSON.parse(userData);

        if(parsedData.user?.companies?.length == 0){
            return null;
        }
        const selectedCompany = parsedData.user?.companies?.find(c => c.selected === 1);

        if(!selectedCompany){
           if(parsedData.user?.companies) {
               return parsedData.user?.companies[0].user_id;
           }
           return parsedData.user.id;
        }

        return selectedCompany ? selectedCompany.user_id : null;
    },
    refreshToken: async () => {
        const {isRefreshing, setIsRefreshing, refreshSubscribers, addSubscriber, clearSubscribers} = useTokenRefresh();

        if (isRefreshing) {
            return new Promise((resolve, reject) => {
                addSubscriber({resolve, reject});
            });
        }

        const userData = localStorage.getItem('users');
        if (!userData) {

            return false;
        }

        const data = JSON.parse(userData);

        const config = {
            headers: {
                'Authorization': `Bearer ${data.data.token}`,
                'Content-Type': 'application/json'
            }
        };

        setIsRefreshing(true);

        try {
            const response = await axios.post(process.env.REACT_APP_URL_API + 'refresh', {}, config);

            if (response.code === 200) {

                data.data.token = response.data.token;
                data.data.expires_in_date = Date.now() + ((response.data.expires_in - 30) * 1000);
                localStorage.setItem('users', JSON.stringify(data));

                refreshSubscribers.forEach(subscriber => subscriber.resolve(response.data.token));
                clearSubscribers();

                return true;
            } else {

                refreshSubscribers.forEach(subscriber => subscriber.reject(new Error('Falha ao atualizar o token')));
                clearSubscribers();
                return <Navigate  to="/admin/logout"/>;
            }
        } catch (error) {

            refreshSubscribers.forEach(subscriber => subscriber.reject(error));
            clearSubscribers();
            return <Navigate  to="/admin/logout"/>;
        } finally {
            setIsRefreshing(false);
        }
    },

    isTokenExpired: () => {
        const userData = localStorage.getItem('users');

        if (!userData) {
            return true;
        }

        try {
            const parsedData = JSON.parse(userData);

            // Support both formats: {data: {expires_in_date}} and {expires_in_date}
            const expDate = parsedData?.data?.expires_in_date || parsedData?.expires_in_date;
            if (expDate) {
                const expirationDate = new Date(expDate);
                const currentDate = new Date();
                return expirationDate < currentDate;
            } else {
                return true;
            }
        } catch (error) {
            return true;
        }
    },

    updateData: (user) => {
        const stored = JSON.parse(localStorage.getItem('users')) || {};
        const updatedUser = {
            ...stored,
            user: {
                ...stored.user,
                ...user
            }
        };
        localStorage.setItem('users', JSON.stringify(updatedUser));
    },

    updateImage: (imagem) => {
        const userData = JSON.parse(localStorage.getItem('users'));
        if (userData && userData.user) {
            userData.user.profile_image = imagem;
            localStorage.setItem('users', JSON.stringify(userData));
        } else {

        }
    }
};

export default AuthService;
